/* UTIL CONSTANTS */
export const excelExtensions = [
  'xls',
  'xlt',
  'xlm',
  'xlsx',
  'xlsm',
  'xltx',
  'xltm',
];
export const wordExtensions = ['docx', 'docm', 'dotx', 'dotm', 'doc', 'dot'];
export const powerpointExtensions = ['pptx', 'pptm', 'ppt'];
export const codeExtensions = ['xml', 'py', 'js', 'css', 'log'];
export const audioExtensions = ['ulaw', 'g729', 'gsm', 'alaw'];
// task_audios: se añadieron oga/opus/m4a/aac/flac porque las notas de voz de WhatsApp
// llegan en esos formatos y antes caían al `else` de getFileType (tarjeta de documento,
// sin reproductor y con el nombre técnico a la vista). Fuera quedan `webm` (ya es video)
// y `amr` (Chrome no lo reproduce: sería un player muerto en vez de un archivo descargable).
export const musicExtensions = [
  'mp3',
  'wav',
  'ogg',
  'oga',
  'opus',
  'm4a',
  'aac',
  'flac',
];
export const videoExtensions = ['mp4', 'webm'];
export const imageExtensions = ['jpg', 'png', 'jpeg', 'webp'];

// task_audios: etiqueta con la que se identifican los adjuntos de audio en la
// conversación. El nombre real del archivo (record_<fecha>_<hash>.wav) no aporta nada al
// agente y ocupa el espacio del reproductor. Es solo presentación: la URL completa se
// conserva en el mensaje y la descarga sigue usando el nombre del backend.
export const AUDIO_DISPLAY_LABEL = 'Audio';

// Resuelve la URL del avatar del usuario contra el PbxServer, cayendo al default
// cuando avatar es null/undefined/"" (respuesta válida del backend para "sin foto").
// No usar `'https://' + pbxServer + avatar || default`: la concatenación de strings
// siempre es truthy, así que ese `||` nunca cae al default aunque avatar sea null.
export function resolveAvatarUrl(pbxServer, avatar, { defaultImage = 'static/images/10.png', cacheBust = false } = {}) {
  if (!avatar) return defaultImage;
  const url = `https://${pbxServer}${avatar}`;
  return cacheBust ? `${url}${url.includes('?') ? '&' : '?'}t=${Date.now()}` : url;
}

export function makeid(length) {
  let result = '';
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function formatedDate(stringDate) {
  const now = new Date();
  const date = new Date(stringDate);
  const dateMinutes = date.getMinutes();
  let formatedDate = '';
  const diffTime = Math.abs(now - date);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  if (diffDays === 0) {
    formatedDate = `${date.getHours}:${
      dateMinutes > 10 ? dateMinutes : `0${dateMinutes}`
    }`;
  } else if (diffDays === 1) {
    formatedDate = 'Ayer';
  } else if (diffDays > 1 && diffDays < 7) {
    const options = {
      weekday: 'long',
    };
    formatedDate = date.toLocaleDateString('es-ES', options);
  } else {
    formatedDate = date.toLocaleDateString();
  }
  return formatedDate;
}

export function filesizeFormat(fileSize) {
  let formatSize = 0;
  let sufix = '';
  if (fileSize < 1000) {
    formatSize = fileSize;
    sufix = 'bytes';
  } else {
    fileSize /= 1024;
    if (fileSize < 1000) {
      formatSize = fileSize;
      sufix = 'kB';
    } else {
      fileSize /= 1024;
      if (fileSize < 1000) {
        formatSize = fileSize;
        sufix = 'MB';
      } else {
        fileSize /= 1024;
        formatSize = fileSize;
        sufix = 'GB';
      }
    }
  }

  return `${formatSize.toFixed(2)} ${sufix}`;
}

export function timeFormat(currentTime) {
  currentTime = parseInt(currentTime, 10);
  const hours = String(Math.trunc(currentTime / 3600));
  currentTime -= hours * 3600;
  const minutes = String(Math.trunc(currentTime / 60));
  currentTime -= minutes * 60;
  const seconds = String(currentTime);
  let strTime = '';
  if (hours === '0') {
    strTime = `${minutes.length === 1 ? `0${minutes}` : minutes}:${
      seconds.length === 1 ? `0${seconds}` : seconds
    }`;
  } else {
    strTime = `${hours.length === 1 ? `0${hours}` : hours}:${
      minutes.length === 1 ? `0${minutes}` : minutes
    }:${seconds.length === 1 ? `0${seconds}` : seconds}`;
  }

  return strTime;
}

export function getFileType(fileExtension) {
  let isImage = false;
  let isVideo = false;
  let isAudio = false;
  let isOther = false;
  let isUnknown = false;
  let fileIcon = '';
  let iconPrimaryColor = 'black';
  let iconSecondaryColor = 'white';
  let compactIcon = '';
  let classIcon = '';

  let biIcon = 'bi-file-earmark-fill';
  let iconColor = '#A0A0A0';

  if (imageExtensions.includes(fileExtension.toLowerCase())) {
    isImage = true;
    fileIcon = 'file-image';
    compactIcon = 'faFileImage';
    classIcon = 'bi-file-earmark-image-fill';
    iconPrimaryColor = 'rgb(75,184,155)';
    iconSecondaryColor = 'rgb(190,224,230)';
    biIcon = 'bi-file-earmark-image-fill';
    iconColor = '#4BB89B';
  } else if (excelExtensions.includes(fileExtension.toLowerCase())) {
    isOther = true;
    fileIcon = 'file-excel';
    compactIcon = 'faFileExcel';
    classIcon = 'bi-file-earmark-excel-fill';
    iconPrimaryColor = 'white';
    iconSecondaryColor = 'rgb(49,187,112)';
    biIcon = 'bi-file-earmark-excel-fill';
    iconColor = '#31BB70';
  } else if (wordExtensions.includes(fileExtension.toLowerCase())) {
    isOther = true;
    fileIcon = 'file-word';
    compactIcon = 'faFileWord';
    classIcon = 'bi-file-earmark-word-fill';
    iconPrimaryColor = 'white';
    iconSecondaryColor = 'rgb(43,124,211)';
    biIcon = 'bi-file-earmark-word-fill';
    iconColor = '#2B7CD3';
  } else if (powerpointExtensions.includes(fileExtension.toLowerCase())) {
    isOther = true;
    fileIcon = 'file-powerpoint';
    compactIcon = 'faFilePowerpoint';
    classIcon = 'bi-file-earmark-slides-fill';
    iconPrimaryColor = 'white';
    iconSecondaryColor = 'rgb(237,108,71)';
    biIcon = 'bi-file-earmark-slides-fill';
    iconColor = '#ED6C47';
  } else if (fileExtension.toLowerCase() === 'csv') {
    isOther = true;
    fileIcon = 'file-csv';
    compactIcon = 'faFileCsv';
    classIcon = 'bi-filetype-csv';
    iconPrimaryColor = 'white';
    iconSecondaryColor = 'rgb(49,187,112)';
    biIcon = 'bi-filetype-csv';
    iconColor = '#31BB70';
  } else if (fileExtension.toLowerCase() === 'pdf') {
    isOther = true;
    fileIcon = 'file-pdf';
    compactIcon = 'faFilePdf';
    classIcon = 'bi-file-earmark-pdf-fill';
    iconPrimaryColor = 'white';
    iconSecondaryColor = 'rgb(255,51,51)';
    biIcon = 'bi-file-earmark-pdf-fill';
    iconColor = '#FF3333';
  } else if (fileExtension.toLowerCase() === 'txt') {
    isOther = true;
    fileIcon = 'file-lines';
    compactIcon = 'faFileLines';
    classIcon = 'bi-file-earmark-text-fill';
    iconPrimaryColor = 'white';
    iconSecondaryColor = 'white';
    biIcon = 'bi-file-earmark-text-fill';
    iconColor = '#FFFFFF';
  } else if (codeExtensions.includes(fileExtension.toLowerCase())) {
    isOther = true;
    fileIcon = 'file-code';
    compactIcon = 'faFileCode';
    classIcon = 'bi-file-earmark-code-fill';
    iconPrimaryColor = 'rgb(96,96,96)';
    iconSecondaryColor = 'rgb(255,255,51)';
    biIcon = 'bi-file-earmark-code-fill';
    iconColor = '#606060';
  } else if (audioExtensions.includes(fileExtension.toLowerCase())) {
    isOther = true;
    fileIcon = 'file-audio';
    compactIcon = 'faFileAudio';
    classIcon = 'bi-file-earmark-music-fill';
    iconPrimaryColor = 'rgb(160,160,160)';
    iconSecondaryColor = 'white';
    biIcon = 'bi-file-earmark-music-fill';
    iconColor = '#A0A0A0';
  } else if (musicExtensions.includes(fileExtension.toLowerCase())) {
    isAudio = true;
    isOther = true;
    fileIcon = 'file-music';
    compactIcon = 'faFileMusic';
    classIcon = 'bi-file-earmark-music-fill';
    iconPrimaryColor = 'rgb(160,160,160)';
    iconSecondaryColor = 'white';
    biIcon = 'bi-file-earmark-music-fill';
    iconColor = '#A0A0A0';
  } else if (videoExtensions.includes(fileExtension.toLowerCase())) {
    isVideo = true;
    isOther = true;
    fileIcon = 'file-video';
    compactIcon = 'faFileVideo';
    classIcon = 'bi-file-earmark-play-fill';
    iconPrimaryColor = 'rgb(160,160,160)';
    iconSecondaryColor = 'white';
    biIcon = 'bi-file-earmark-play-fill';
    iconColor = '#A0A0A0';
  } else {
    isOther = true;
    isUnknown = true;
    fileIcon = 'file-lines';
    compactIcon = 'faFileLines';
    classIcon = 'bi-file-earmark-text-fill';
    iconPrimaryColor = 'rgb(160,160,160)';
    iconSecondaryColor = 'white';
    biIcon = 'bi-file-earmark-text-fill';
    iconColor = '#A0A0A0';
  }

  return {
    isImage,
    isVideo,
    isOther,
    isUnknown,
    fileIcon,
    iconPrimaryColor,
    iconSecondaryColor,
    isAudio,
    compactIcon,
    classIcon,
    biIcon,
    iconColor,
  };
}

export function getTimeMessage(messageDate) {
  const date = new Date(messageDate);
  const hours = String(date.getHours());
  let minutes = String(date.getMinutes());
  minutes = minutes.length === 1 ? `0${minutes}` : minutes;
  return `${hours}:${minutes}`;
}

// Formatea un mensaje del chat para copiarlo: "[Remitente dd/mm/aa HH:mm]\ncontenido"
// `contactName` es el nombre del contacto del chat abierto (fallback para Join entrante,
// que es 1-a-1 y cuyo historial no siempre trae el nombre en el propio mensaje).
function formatMessageForCopy(msg, userInfo = {}, contactName = '') {
  const isOut = msg.source === '' || msg.direction === 'out';
  let name;
  if (isOut) {
    // Propio: en Join el agente que envía viene en owner_message; en SipMóvil el
    // display está en author[1]. author[0] (username/número) queda como último recurso.
    name =
      msg.owner_message ||
      (msg.author && msg.author[1]) ||
      userInfo.User || userInfo.Username ||
      (msg.author && msg.author[0]);
  } else {
    // Entrante: nombre del autor; en Join 1-a-1 cae al contacto del chat abierto.
    name =
      (msg.author && msg.author[1]) ||
      msg.sender_custom_name || msg.sender_name || msg.contact || contactName ||
      (msg.author && msg.author[0]);
  }
  name = name || 'Desconocido';
  const d = new Date(msg.created_at || msg.timestamp);
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yy = String(d.getFullYear()).slice(-2);
  const content =
    msg.message || msg.content || msg.payload?.caption || msg.payload?.text || msg.file_message || '';
  return `[${name} ${dd}/${mm}/${yy} ${getTimeMessage(msg.created_at || msg.timestamp)}]\n${content}`;
}

// Arma el texto de los mensajes seleccionados (por id) en orden cronológico.
// `messages` es el array del store agrupado por fecha ({ time, data: [...] }).
export function buildMessagesCopyText(messages, selectedIds, userInfo = {}, contactName = '') {
  const ids = selectedIds || [];
  const flat = (messages || []).flatMap((g) => g.data || []);
  const selected = flat
    .filter((m) => ids.includes(m.id))
    .sort(
      (a, b) =>
        new Date(a.created_at || a.timestamp) - new Date(b.created_at || b.timestamp)
    );
  return selected.map((m) => formatMessageForCopy(m, userInfo, contactName)).join('\n\n');
}

// Copia texto al portapapeles con fallback para navegadores/contextos sin Clipboard API.
export async function copyTextToClipboard(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (e) {
    // continúa al fallback
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch (e) {
    return false;
  }
}

export function getDayName(dayNumber) {
  const days = [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
  ];
  return days[dayNumber];
}

export function wpMessageTime(itemDate) {
  const today = new Date();
  itemDate = new Date(itemDate);
  const diffTime = Math.abs(itemDate - today);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  let strDate = '';
  if (diffDays === 1) {
    strDate = 'Hoy';
  } else if (diffDays === 2) {
    strDate = 'Ayer';
  } else if (diffDays > 2 && diffDays <= 6) {
    strDate = getDayName(itemDate.getUTCDay());
  } else {
    strDate = `${itemDate.getDate()}/${
      itemDate.getMonth() + 1
    }/${itemDate.getFullYear()}`;
  }
  return strDate;
}

export function wpDialogTime(itemDate) {
  const today = new Date();
  const diffTime = Math.abs(itemDate - today);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  let strDate = '';
  if (diffDays === 1) {
    const itemDateDay = itemDate.getDay();
    const dateDay = today.getDay();
    if (itemDateDay !== dateDay) {
      strDate = 'Ayer';
    } else {
      const minutes = itemDate.getMinutes();
      strDate = `${itemDate.getHours()}:${
        String(minutes).length === 1 ? `0${minutes}` : minutes
      }`;
    }
  } else if (diffDays > 1 && diffDays <= 6) {
    strDate = getDayName(itemDate.getDay());
  } else {
    strDate = `${itemDate.getDate()}/${
      itemDate.getMonth() + 1
    }/${itemDate.getFullYear()}`;
  }
  return strDate;
}

// Escapa el texto y envuelve las coincidencias de `query` en <mark> (para usar con v-html)
export function highlightText(text, query) {
  if (!text) return '';
  const escapeHtml = (value) => value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
  const safeText = escapeHtml(text);
  const term = query ? query.trim() : '';
  if (!term) return safeText;
  const safeTerm = escapeHtml(term).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return safeText.replace(new RegExp(`(${safeTerm})`, 'gi'), '<mark>$1</mark>');
}

// Crear funcion para obtener el tipo de mansaje para gupshup
// export function getType
export const gupshupAudio = [
  'audio/wav',
  'audio/aac',
  'audio/mp3',
  'audio/amr',
  'audio/mpeg',
  'audio/mp4',
  'audio/ogg; codecs=opus',
];
export const gupshupVideo = ['video/mp4', 'video/3gpp'];
export const gupshupSticker = ['image/webp'];
export const gupshupImage = ['image/jpeg', 'image/png'];

export function getGupchupTypeMessage(file, url) {
  const messagePayload = {};
  if (gupshupAudio.includes(file.type.toLowerCase())) {
    messagePayload.type = 'audio';
    messagePayload.url = url;
    messagePayload.caption = file.name;
  } else if (gupshupVideo.includes(file.type.toLowerCase())) {  
    messagePayload.type = 'video';
    messagePayload.url = url;
    messagePayload.caption = file.name;
  } else if (gupshupSticker.includes(file.type.toLowerCase())) {
    messagePayload.type = 'sticker';
    messagePayload.url = url;
  } else if (gupshupImage.includes(file.type.toLowerCase())) {
    messagePayload.type = 'image';
    messagePayload.originalUrl = url;
    messagePayload.previewUrl = url;
    messagePayload.caption = file.name;
  } else {
    messagePayload.type = 'file';
    messagePayload.url = url;
    messagePayload.filename = file.name;
  }
  return messagePayload;
}
